import React, { memo } from 'react';
import QrCode from './QrCode/QrCode';
import * as CSS from './QrCodePopup.scss';

interface IParentProps {
	//   onClose: () => any;
	webUrl: string;
}

const QrCodePopup: React.FunctionComponent<IParentProps> = ({ webUrl }) => {
	return (
		<div className={CSS.Modal}>
			<div className={CSS.Tip} />
			{/* <div className={CSS.Close} onClick={onClose}>
                <Cross hexFill="#707070" />
            </div> */}
			<div className={CSS.QrCodeContainer}>
				<QrCode webUrl={webUrl} />
			</div>
			<div style={{ fontSize: '12px', textAlign: 'center', color: 'black' }}>Scan the QR code to launch AR experience</div>
		</div>
	);
};

export default memo(QrCodePopup);
